import styled, {css} from 'styled-components';

import {Button as BaseButton} from '@edna/components';
import {mixins} from '@edna/components/styles';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Items = styled.div<{gap: number}>`
  ${mixins.scroll({isVisibleOnHover: true})};
  display: flex;
  gap: ${({gap}) => gap}px;
  align-items: stretch;
  width: 100%;
  overflow-x: scroll;
  scroll-behavior: auto;

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: transparent;
    }
  }
`;

export const Button = styled(BaseButton).attrs((props) => ({appearance: 'secondary', ...props}))<{
  position: 'left' | 'right';
}>`
  ${mixins.wh('32px')};
  position: absolute;
  top: 50%;
  padding: 0;
  border-radius: 50%;

  ${({position}) => css`
    right: ${position === 'right' ? '-16px' : 'unset'};
    left: ${position === 'left' ? '-16px' : 'unset'};
  `}

  svg {
    ${mixins.wh('26px')};
  }
`;
